module.exports = __webpack_public_path__ + "static/img/afm-logo-black.0f986b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afm-logo-black.png
// module id = jfKj
// module chunks = 1